// extracted by mini-css-extract-plugin
module.exports = {"h1":"heading_h1__1tiXK","scaleToSize":"heading_scaleToSize__1fnaZ","fadeIn":"heading_fadeIn__1OpBl","fadeOut":"heading_fadeOut__2at2C"};